import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';
import {
  DEFAULT_DROPDOWN_PAGE_SIZE,
  DEFAULT_DROPDOWN_PAGE_SIZE_NO_PAGINATION,
} from '~settings/constants';

export function useDropdownPageSize(perPage?: number) {
  const [isDropdownPaginationEnabled] = useFeatureFlags([
    FEATURE_FLAGS.ContainerSettingsDropdownPagination,
  ]);

  return (
    perPage ??
    (isDropdownPaginationEnabled
      ? DEFAULT_DROPDOWN_PAGE_SIZE
      : DEFAULT_DROPDOWN_PAGE_SIZE_NO_PAGINATION)
  );
}
